import React from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import { isHexColorBright } from '../../../utils';
import { TooltipWrapper } from 'react-lib/dist/components-es';

type Props = {
  label: string;
  value: string;
  value2?: string;
  display: boolean;
  levelColor: string;
  tooltip: string;
  id: string;
};

const Risk = ({ label, value, value2, display, levelColor, tooltip, id }: Props) => {
  const { t } = useTranslation();

  return display ? (
    <span
      id={id}
      className="riskValue"
      style={{
        backgroundColor: levelColor,
        color: isHexColorBright(levelColor) ? 'black' : 'white',
      }}
    >
      <TooltipWrapper tooltip={tooltip} />
      {t(label, {
        value: t(value),
        value2: value2,
      })}
    </span>
  ) : null;
};

export default withTranslation()(Risk);
